import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpCommonService } from '@shared/services/http-common.service';
import { GenericHttpResponse } from '@shared/services/interfaces/generic-http-response.interface';

import { EmbrionFresco, EmbrionFrescoQueryParams } from './frescos.interface';

@Injectable({
  providedIn: 'root',
})
export class FrescosService {
  private http = inject(HttpClient);
  private httpCommonService = inject(HttpCommonService);

  index(params?: EmbrionFrescoQueryParams): Observable<GenericHttpResponse<EmbrionFresco[]>> {
    const url = this.httpCommonService.makeUrl('/labs/embriones-frescos', params);

    return this.http.get<GenericHttpResponse<EmbrionFresco[]>>(url);
  }
}
